import { Textarea, Radio, Checkbox, Stack, Group } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { TForm, TQuestion } from "../../../types/Aula";

export const QuestionRenderer = ({
  question,
  form,
  timeLeft,
}: {
  question: TQuestion;
  form: UseFormReturnType<TForm>;
  timeLeft: number | null;
}) => {
  const choices = question.choices;
  const disabled = timeLeft !== null ? timeLeft <= 0 : false;

  switch (question.category) {
    case "from_1_to_10":
      return (
        <Radio.Group {...form.getInputProps(question.id)} error={form.errors[question.id]}>
          <Group align="center" gap="xl">
            {choices.map((choice) => (
              <Radio key={choice.id} value={choice.id} label={choice.description} disabled={disabled} />
            ))}
          </Group>
        </Radio.Group>
      );
    case "open_answer":
      return (
        <Group align="center" justify="center" gap="xs">
          <Textarea
            placeholder="Escribe tu respuesta aquí"
            radius="sm"
            autosize
            w="35vw"
            minRows={3}
            maxRows={4}
            {...form.getInputProps(question.id)}
          />
        </Group>
      );
    case "single_choice":
    case "true_or_false":
    case "utility_level":
    case "satisfaction_level":
      return (
        <Radio.Group {...form.getInputProps(question.id)} error={form.errors[question.id]}>
          <Stack gap="xs">
            {choices.map((choice) => (
              <Radio key={choice.id} value={choice.id} label={choice.description} disabled={disabled} />
            ))}
          </Stack>
        </Radio.Group>
      );
    case "multiple_choice":
      return (
        <Checkbox.Group {...form.getInputProps(question.id, { type: "checkbox" })} error={form.errors[question.id]}>
          <Stack gap="xs">
            {choices.map((choice) => (
              <Checkbox key={choice.id} value={choice.id} label={choice.description} disabled={disabled} />
            ))}
          </Stack>
        </Checkbox.Group>
      );
    default:
      return null;
  }
};
